<template>
  <!-- 代理商新增，修改 -->
  <div>
    <el-dialog
      append-to-body
      title="编辑"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="会员卡名称" required>
          <el-input
            v-model="form.name"
            placeholder="会员卡名称"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="有效期/天" prop="duration">
          <el-input
            v-model="form.duration"
            placeholder="会员卡有效期"
          ></el-input>
        </el-form-item>
      
        <el-form-item label="会员卡介绍">
          <el-input
            type="textarea"
            rows="5"
            v-model="form.descr"
            placeholder="会员卡介绍"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          v-if="form.id"
          type="primary"
          @click="updateForm"
          :loading="loading"
          >更 新</el-button
        >
        <el-button v-else type="primary" :loading="loading" @click="addForm"
          >新 增</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { ObjectChangedValue } from "@/js/utils.js";
import { cardRules } from "./rules.js";
export default {
  data() {
    return {
      rules: cardRules,
      clear: false,
      form: { service_type: "", name: "", count: "" },
      temp: {},
      dialogVisible: false,
      loading: false,
      device: {},
      coop_id: 0
    };
  },
  mounted() {
   this.coop_id = this.$route.query.id
  },

  methods: {
    getName() {
      let name = `${this.form.service_type == 1 ? "整场" : "人数"}-${
        this.form.type == 1 ? "闲" : "忙"
      }-${this.form.duration}h-${this.form.price}元`;
      this.form.name = name;
    },
    addForm() {
      this.form.coop_id = this.coop_id
      this.form.type = 3
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$axios({
            url: "/user/mechanismCard/insert",
            method: "post",
            data: this.form,
          })
            .then((res) => {
              this.$notify({
                message: "新增成功",
                duration: 2000,
                type: "success",
              });
              this.dialogVisible = false;
              this.loading = false;
              this.$emit("success", 1);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    updateForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = ObjectChangedValue(this.temp, this.form);
          if (Object.keys(data).length == 0) {
            this.$message("没有修改数据，无需更新");
            return;
          }
          this.loading = true;
          this.$axios({
            url: "/user/mechanismCard/update",
            method: "post",
            data: {
              id: this.form.id,
              ...data,
            },
          })
            .then((res) => {
              this.$notify({
                message: "更新成功",
                duration: 2000,
                type: "success",
              });
              this.dialogVisible = false;
              this.loading = false;
              this.$emit("success", 1);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    open(info, device) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = { service_type: "", name: "", count: "" };
        this.temp = {};
      }
      if (device) {
        this.device = device;
        if (this.device.type == "person") {
          this.form.service_type = 2;
        } else {
          this.form.service_type = 1;
        }
        this.form.count = this.device.max_people;
        this.form.teaching = this.device.teaching;
      }
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
</style>